<template>
  <div class="slide-verify-page">
    <div class="slider-container"
         @mousedown="startDrag"
         @mouseup="endDrag"
         @mousemove="onDrag"
         @mouseleave="endDrag"
         @touchstart.prevent="startTouch"
         @touchmove.prevent="onTouchMove"
         @touchend="endTouch">
      <div class="slider-track">
        <div
          class="slider-thumb"
          :class="{ 'no-transition': dragging || verified }"
          :style="{ left: thumbLeft + 'px' }"
        >
          <span class="slider-arrow">&gt;&gt;&gt;</span>
        </div>
      </div>
      <div class="slider-text">{{ sliderText }}</div>
    </div>
    <div v-if="showFailPopup" class="fail-popup">{{ failMsg }}</div>
  </div>
</template>

<script>
export default {
  name: 'SlideVerifyPage',
  data() {
    return {
      dragging: false,
      startX: 0,
      thumbLeft: 0,
      // 这里根据容器宽度与滑块宽度调整最大值
      maxLeft: 250,  // 300（容器宽） - 50（滑块宽）=250
      sliderText: '向右滑动完成验证',
      verified: false,
      showFailPopup: false,
      failMsg: ''
    };
  },
   mounted() {
    if (this.$parent && typeof this.$parent.footer === 'function') {
      this.$parent.footer('index', false);
    }
  }, 
  methods: {
    startDrag(event) {
      if (this.verified) return;
      this.dragging = true;
      this.startX = event.clientX;
      this.hideFailPopup();
    },
    onDrag(event) {
      if (!this.dragging) return;
      let moveX = event.clientX - this.startX;
      if (moveX < 0) moveX = 0;
      if (moveX > this.maxLeft) moveX = this.maxLeft;
      this.thumbLeft = moveX;
      if (moveX === this.maxLeft) {
        this.completeVerification();
      }
    },
    endDrag() {
      if (!this.dragging) return;
      this.dragging = false;
      if (!this.verified) {
        this.thumbLeft = 0; // 让滑块回滚
        this.showFailPopupMessage('验证失败，请重试');
      }
    },
    startTouch(event) {
      if (this.verified) return;
      this.dragging = true;
      this.startX = event.touches[0].clientX;
      this.hideFailPopup();
    },
    onTouchMove(event) {
      if (!this.dragging) return;
      let moveX = event.touches[0].clientX - this.startX;
      if (moveX < 0) moveX = 0;
      if (moveX > this.maxLeft) moveX = this.maxLeft;
      this.thumbLeft = moveX;
      if (moveX === this.maxLeft) {
        this.completeVerification();
      }
    },
    endTouch() {
      if (!this.dragging) return;
      this.dragging = false;
      if (!this.verified) {
        this.thumbLeft = 0; // 回滚
        this.showFailPopupMessage('验证失败，请重试');
      }
    },
    completeVerification() {
      if (this.verified) return;
      if (this.thumbLeft !== this.maxLeft) {
        this.showFailPopupMessage('请滑动到最右边完成验证');
        this.thumbLeft = 0; // 回滚滑块
        return;
      }
      this.verified = true;
      sessionStorage.setItem('isAuthenticated', 'true');
      this.sliderText = '验证成功！';
      setTimeout(() => {
        const redirect = this.$route.query.redirect || '/';
        // const redirect = '/';
        // 强制跳转
        window.location.href = redirect;
      }, 500);
    },
    showFailPopupMessage(msg) {
      this.failMsg = msg;
      this.showFailPopup = true;
      // 提示持续时间更长
      setTimeout(() => {
        this.showFailPopup = false;
      }, 1500); // 改长提示时间
    },
    hideFailPopup() {
      this.showFailPopup = false;
      this.failMsg = '';
    }
  }
};
</script>

<style scoped>
.slide-verify-page {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  background: url(../../views/images/index/verify-bg.0a57f0eb.png) no-repeat;
  background-size: cover;
  background-position: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}
.slider-container {
  width: 300px;
  height: 50px;
  background-color: transparent; /* 背景透明 */
  border-radius: 25px;
  border: 2px solid #fff; /* 白色边框 */
  position: relative;
  user-select: none;
  cursor: grab;
  box-sizing: border-box;
}
.slider-track {
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;
}
.slider-thumb {
  width: 50px;
  height: 50px;
  background-color: transparent; /* 背景透明 */
  border-radius: 50%;
  position: absolute;
  margin-left: 2px;
  top: 0;
  left: 0;
  transition: left 0.5s ease-out;
  /* box-shadow: 0 2px 8px rgba(0,0,0,0.15); */
  display: flex;
  align-items: center;
  justify-content: center;
}
.slider-arrow {
  color: #fff;
  font-size: 28px;
  font-weight: bold;
  user-select: none;
  pointer-events: none;
}
.slider-thumb.no-transition {
  transition: none !important;
}
.slider-text {
  position: absolute;
  width: 100%;
  height: 100%;
  line-height: 50px;
  text-align: center;
  color: #fff; /* 白色文字 */
  font-weight: bold;
  pointer-events: none;
  z-index: 2;
  left: 0;
  top: 0;
  font-size: 16px;
}
.fail-popup {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  padding: 10px 20px;
  background-color: rgba(0, 0, 0, 0.7);
  color: white;
  font-size: 16px;
  border-radius: 5px;
  z-index: 1000;
  animation: fadeOut 3s forwards;
}
@keyframes fadeOut {
  0% { opacity: 1; }
  66% { opacity: 1; }
  100% { opacity: 0; }
}
</style>
